module.exports = __webpack_public_path__ + "img/anjoman.b0f1797.svg";